module.exports = __webpack_public_path__ + "img/remover.e78d0e78.svg";